export const setDynamicCopyright = () => {
  const date = new Date().getFullYear().toString();
  const footerDateSpan = document.querySelector("#copyright-date");
  footerDateSpan!.innerHTML = date;
};
